export default {
    automatic_sprinkler_control_valve: {
        name: "Automatic Sprinkler Control Valve",
        url: "nfpa_fire_service/automatic_sprinkler_control_valve",
    },
    childcare_center: {
        name: "Childcare Center",
        url: "nfpa_fire_service/childcare_center",
    },
    diagonal_directional_arrow: {
        name: "Diagonal Directional Arrow",
        url: "nfpa_fire_service/diagonal_directional_arrow",
    },
    directional_arrow: {
        name: "Directional Arrow",
        url: "nfpa_fire_service/directional_arrow",
    },
    dry_hydrant: {
        name: "Dry Hydrant",
        url: "nfpa_fire_service/dry_hydrant",
    },
    electric_panel_or_electric_shutoff: {
        name: "Electric Panel Or Electric Shutoff",
        url: "nfpa_fire_service/electric_panel_or_electric_shutoff",
    },
    emergency_telephone: {
        name: "Emergency Telephone",
        url: "nfpa_fire_service/emergency_telephone",
    },
    "fire_department_automatic_sprinkler_connection_-_siamese": {
        name: "Fire Department Automatic Sprinkler Connection - Siamese",
        url: "nfpa_fire_service/fire_department_automatic_sprinkler_connection_-_siamese",
    },
    "fire_department_automatic_sprinkler_connection_-_single": {
        name: "Fire Department Automatic Sprinkler Connection - Single",
        url: "nfpa_fire_service/fire_department_automatic_sprinkler_connection_-_single",
    },
    fire_department_combined_automatic_sprinkler: {
        name: "Fire Department Combined Automatic Sprinkler",
        url: "nfpa_fire_service/fire_department_combined_automatic_sprinkler",
    },
    fire_department_standpipe_connection: {
        name: "Fire Department Standpipe Connection",
        url: "nfpa_fire_service/fire_department_standpipe_connection",
    },
    fire_extinguisher: {
        name: "Fire Extinguisher",
        url: "nfpa_fire_service/fire_extinguisher",
    },
    fire_hydrant: {
        name: "Fire Hydrant",
        url: "nfpa_fire_service/fire_hydrant",
    },
    firefighting_hose_or_standpipe_outlet: {
        name: "Firefighting Hose Or Standpipe Outlet",
        url: "nfpa_fire_service/firefighting_hose_or_standpipe_outlet",
    },
    gas_shutoff_valve: {
        name: "Gas Shutoff Valve",
        url: "nfpa_fire_service/gas_shutoff_valve",
    },
    no_firefighting: {
        name: "No Firefighting",
        url: "nfpa_fire_service/no_firefighting",
    },
}
